export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAH0lEQVR42mNgYGD4TyFm+F9eXk4WHjVg1ADqGkAJBgAxJoKMasTLeQAAAABJRU5ErkJggg=="